/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOpexVariantRequestDto } from '../../models/backend-opex-variant-request-dto';
import { BackendOpexVariantResponseDto } from '../../models/backend-opex-variant-response-dto';

export interface OpexesVariantsCreate$XWwwFormUrlencoded$Params {
  body: BackendOpexVariantRequestDto;
}

export function opexesVariantsCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: OpexesVariantsCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOpexVariantResponseDto>> {
  const rb = new RequestBuilder(rootUrl, opexesVariantsCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOpexVariantResponseDto>;
    }),
  );
}

opexesVariantsCreate$XWwwFormUrlencoded.PATH = '/api/opexes/variants/';
